import { styled } from "styled-components";
import { FaChevronDown } from "react-icons/fa";
import { createStyledIcon } from "utils/iconUtils";

const ArrowIconDown = createStyledIcon(FaChevronDown);

export const SelectContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const StyledSelect = styled.select`
  width: 100%;
  height: 40px;
  padding: ${({ theme }) => theme.spacing.sm};
  padding-right: calc(${({ theme }) => theme.spacing.sm} * 2);
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  background: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.secondary};
  appearance: none;

  &:focus {
    outline: none;
  }
`;

export const ArrowIcon = styled(ArrowIconDown)`
  position: absolute;
  top: 50%;
  right: ${({ theme }) => theme.spacing.sm};
  transform: translateY(-50%);
  pointer-events: none;
  color: ${({ theme }) => theme.colors.primary};
`;
